import { Component, ElementRef, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { FormGroup, FormControl, Validators, FormBuilder } from '@angular/forms';
import { Router } from '@angular/router';
import { MessagesService } from '../core/services/messages/messages.service';
import { RequestServiceService } from '../core/services/request-service/request-service.service';
import { Subscription, timer } from 'rxjs';

@Component({
  selector: 'app-forgot-password',
  templateUrl: './forgot-password.component.html',
  styleUrls: ['./forgot-password.component.scss']
})
export class ForgotPasswordComponent implements OnInit, OnDestroy{
  pwdType: any = true;
  otpVal: any
  loading: boolean = false;
  passwordForm: FormGroup = new FormGroup({
    otp: new FormControl('', [Validators.required]),
    new_password: new FormControl('', [Validators.required, Validators.minLength(8)]),
    confirm_password: new FormControl('', [Validators.required]),
  });
  submitted: boolean = false;
  email:any;
 

  constructor(private requestApiService: RequestServiceService, public router: Router,
    public messageservices: MessagesService) { 
    
    }
    private timerSubscription: Subscription | undefined;
    public timeLeft: string = '00:00';
    ngOnInit() {
      // Set the initial time (you can adjust this based on your requirements)
     // this.timeLeft = this.formatTime(92); // 92 seconds as an example
      this.updateTime();
      // Set up a timer that updates every second
      this.timerSubscription = timer(1000, 1000).subscribe(() => {
        this.updateTime();
      });
    }
  getOtp(otp: any) {
    this.otpVal = otp;
  }
  
  ngOnDestroy() {
    // Unsubscribe from the timer to avoid memory leaks
    this.timerSubscription?.unsubscribe();
  }
  private expirationTime: number = new Date().getTime() + 30 * 1000; // S
  updateTime() {
    const currentTime = new Date().getTime();
    const remainingTime = Math.max(0, this.expirationTime - currentTime);
    this.timeLeft = this.formatTime(remainingTime / 1000);

    if (remainingTime === 0) {
      this.timerSubscription?.unsubscribe(); // Stop the timer when it reaches 0
      // Do something when the time is up
    }
  }

  formatTime(seconds: number): string {
    const minutes = Math.floor(seconds / 60);
    const remainingSeconds = Math.floor(seconds % 60);
    return `${this.pad(minutes)}:${this.pad(remainingSeconds)}`;
  }

  

  pad(value: number): string {
    // Helper function to pad single-digit numbers with a leading zero
    return value < 10 ? `0${value}` : `${value}`;
  }

  isTimerExpired(): boolean {
    // Check if the timer has reached 0
    return this.getSecondsLeft() === 0;
  }
  sendOtp() {
    this.submitted = true
   this.email=localStorage.getItem('email');
      let data = {
        "email":this.email,
        "otp_type": "forgot_password",
        "otp_entity": "merchant"
      }
      localStorage.clear()
      this.requestApiService.verifyEmail(data).then(response => {
        if (response.success) {
          localStorage.setItem('authToken', response.data.token)
          localStorage.setItem('email', this.email)
          this.expirationTime = new Date().getTime() + 30 * 1000;
          this.updateTime();
      // Set up a timer that updates every second
      this.timerSubscription = timer(1000, 1000).subscribe(() => {
        this.updateTime();
      });
          this.messageservices.showNotification(response.msg, 'success', 'success');
        } else {
          this.messageservices.showNotification(response.msg, 'error', 'error');
        }
      });
    
  }
  getSecondsLeft(): number {
    const currentTime = new Date().getTime();
   
    return Math.max(0, this.expirationTime - currentTime);
  }
  onSubmit() {
    const new_password = this.passwordForm.get('new_password')?.value;
    const confirm_password = this.passwordForm.get('confirm_password')?.value;
    if (new_password === confirm_password) {
      let data = {
        "otp": this.otpVal,
        "new_password": new_password,
        "confirm_password": confirm_password
      }
      this.requestApiService.resetPassword(data).then(response => {
        if (response.success) {
          this.router.navigate([`/`]);
          localStorage.clear()
          this.messageservices.showNotification(response.msg, 'success', 'success');
        } else {
          this.messageservices.showNotification(response.msg, 'error', 'error');
        }
      });
    } else {
      this.messageservices.showNotification('Passwords do not match.', 'success', 'success');
     
    }
  }
  togglePwdType = () => {
    this.pwdType = !this.pwdType;
  }
}